/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Util", "react", "../../Contracts/KubeServiceBase", "../Common/KubeFilterBar", "../Common/KubeZeroData", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../ImageDetails/ImageDetailsActionsCreator", "../KubeFactory", "../Pods/PodsActionsCreator", "../Pods/PodsStore", "../Utils", "./DeploymentsTable", "./OtherWorkloadsTable", "./WorkloadsActionsCreator", "./WorkloadsFilterBar", "./WorkloadsStore", "../Common/KubeSummary.scss", "./WorkloadsPivot.scss"], function (require, exports, String_1, Util_1, React, KubeServiceBase_1, KubeFilterBar_1, KubeZeroData_1, Constants_1, ActionsCreatorManager_1, StoreManager_1, ImageDetailsActionsCreator_1, KubeFactory_1, PodsActionsCreator_1, PodsStore_1, Utils_1, DeploymentsTable_1, OtherWorkloadsTable_1, WorkloadsActionsCreator_1, WorkloadsFilterBar_1, WorkloadsStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WorkloadsPivot = /** @class */ (function (_super) {
        __extends(WorkloadsPivot, _super);
        function WorkloadsPivot(props) {
            var _this = _super.call(this, props, {}) || this;
            _this._onPodsFetched = function () {
                var podlist = _this._podsStore.getState().podsList;
                if (podlist && podlist.items && podlist.items.length > 0) {
                    var imageList = Utils_1.Utils.getImageIdsForPods(podlist.items);
                    _this.setState({
                        imageList: imageList
                    });
                }
            };
            _this._onDataFound = function () {
                var workloadSize = _this._workloadsStore.getWorkloadSize();
                if (_this.state.workloadResourceSize <= 0 && workloadSize > 0) {
                    _this.setState({ workloadResourceSize: workloadSize }, function () {
                        _this._componentsInitialized = {
                            "DeploymentTable": false,
                            "OtherWorkloads": false
                        };
                    });
                }
            };
            _this._notifyRender = function (props) {
                if (!_this._isTTIMarked && props && _this._componentsInitialized) {
                    props["component"] ? _this._componentsInitialized[props["component"]] = true : undefined;
                    var initialized_1 = true;
                    Object.keys(_this._componentsInitialized).forEach(function (key) { return initialized_1 = initialized_1 && _this._componentsInitialized[key]; });
                    if (initialized_1 && !_this._isTTIMarked) {
                        KubeFactory_1.getTelemetryService().scenarioEnd(Constants_1.Scenarios.Workloads);
                        _this._isTTIMarked = true;
                    }
                }
            };
            _this._isTTIMarked = false;
            KubeFactory_1.getTelemetryService().scenarioStart(Constants_1.Scenarios.Workloads);
            _this._workloadsStore = StoreManager_1.StoreManager.GetStore(WorkloadsStore_1.WorkloadsStore);
            // initialize pods store as pods list will be required in workloadPodsView on item selection
            _this._podsStore = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore);
            _this._podsActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(PodsActionsCreator_1.PodsActionsCreator);
            _this._imageActionsCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator);
            _this._workloadsActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(WorkloadsActionsCreator_1.WorkloadsActionsCreator);
            _this.state = {
                workloadResourceSize: 0,
                imageList: []
            };
            _this._podsStore.addListener(Constants_1.PodsEvents.PodsFetchedEvent, _this._onPodsFetched);
            _this._workloadsStore.addListener(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, _this._onDataFound);
            var kubeService = KubeFactory_1.KubeFactory.getKubeService();
            _this._workloadsActionCreator.getDeployments(kubeService);
            // fetch all pods in parent component as the podList is required in selected workload pods view
            _this._podsActionCreator.getPods(kubeService);
            return _this;
        }
        WorkloadsPivot.prototype.render = function () {
            return (React.createElement(React.Fragment, null,
                this._getFilterBar(),
                React.createElement("div", { className: Util_1.css("workloads-pivot-data", "k8s-pivot-data") }, this._getContent())));
        };
        WorkloadsPivot.prototype.componentWillUnmount = function () {
            this._workloadsStore.removeListener(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, this._onDataFound);
            this._podsStore.removeListener(Constants_1.PodsEvents.PodsFetchedEvent, this._onPodsFetched);
        };
        WorkloadsPivot.prototype.componentDidUpdate = function (prevProps, prevState) {
            var imageService = KubeFactory_1.KubeFactory.getImageService();
            imageService && (this.state.imageList.length > 0) && this._imageActionsCreator.setHasImageDetails(imageService, this.state.imageList);
        };
        WorkloadsPivot.prototype._getContent = function () {
            return (this.state.workloadResourceSize === 0 ? this._getZeroData() :
                React.createElement(React.Fragment, null,
                    this._showComponent(KubeServiceBase_1.KubeResourceType.Deployments) && this._getDeployments(),
                    this._getOtherWorkloadsComponent()));
        };
        WorkloadsPivot.prototype._getFilterBar = function () {
            return (React.createElement(WorkloadsFilterBar_1.WorkloadsFilterBar, { filter: this.props.filter, filterToggled: this.props.filterToggled, className: Util_1.css("workloads-pivot-filter", "k8s-pivot-filter") }));
        };
        WorkloadsPivot.prototype._getOtherWorkloadsComponent = function () {
            return (React.createElement(OtherWorkloadsTable_1.OtherWorkloads, { key: String_1.format("sts-list-{0}", this.props.namespace || ""), nameFilter: this._getNameFilterValue(), typeFilter: this._getTypeFilterValue(), markTTICallback: this._notifyRender }));
        };
        WorkloadsPivot.prototype._getDeployments = function () {
            return (React.createElement(DeploymentsTable_1.DeploymentsTable, { key: String_1.format("dc-{0}", this.props.namespace || ""), nameFilter: this._getNameFilterValue(), markTTICallback: this._notifyRender }));
        };
        WorkloadsPivot.prototype._getNameFilterValue = function () {
            var filterState = this.props.filter.getState();
            var filterItem = filterState ? filterState[KubeFilterBar_1.NameKey] : null;
            return filterItem ? filterItem.value : undefined;
        };
        WorkloadsPivot.prototype._getTypeFilterValue = function () {
            var filterState = this.props.filter.getState();
            var filterItem = filterState ? filterState[KubeFilterBar_1.TypeKey] : null;
            var selections = filterItem ? filterItem.value : [];
            return selections;
        };
        WorkloadsPivot.prototype._showComponent = function (resourceType) {
            var selections = this._getTypeFilterValue();
            // if no filter selections are made, show all components
            if (selections.length > 0 && resourceType != undefined) {
                var selection = resourceType.toString();
                return selections.indexOf(selection) != -1;
            }
            return true;
        };
        WorkloadsPivot.prototype._getZeroData = function () {
            return KubeZeroData_1.KubeZeroData.getWorkloadsZeroData();
        };
        return WorkloadsPivot;
    }(React.Component));
    exports.WorkloadsPivot = WorkloadsPivot;
});
